// GCCV2TimingResult.tsx
import React from "react";
import GCCV2TabDashboard from "./GCCV2TabDashboard";
import { getGCCV2StrictLanguageInstruction } from "../../../utils/GCC/astriaGCCV2Language";

const PROMPT = {
  en: (dob: string) =>
    `Give me today's GCC Timing reading — my emotional rhythm, decision rhythm, and momentum for today.\nDate of Birth: ${dob}\n${getGCCV2StrictLanguageInstruction("en")}`,
  ar: (dob: string) =>
    `أعطني قراءة "الإيقاع" الخاصة بي اليوم — إيقاعي العاطفي، وإيقاع القرار، والزخم اليوم.\nتاريخ الميلاد: ${dob}\n${getGCCV2StrictLanguageInstruction("ar")}`,
};

const GCCV2TimingResult: React.FC = () => (
  <GCCV2TabDashboard
    tab="timing"
    tabKey="timing"
    subCategoryMatch="timing"
    buildPrompt={(dob, language) => PROMPT[language](dob)}
    title={{ en: "Today's Timing", ar: "إيقاع اليوم" }}
    subtitle={{
      en: "Your emotional rhythm, decision rhythm, and momentum for today.",
      ar: "إيقاعك العاطفي وإيقاع قراراتك وزخمك اليوم.",
    }}
    progressCardIndex={2}
    progressLabel={{ en: "Momentum", ar: "الزخم" }}
  />
);

export default GCCV2TimingResult;
